import requests from "./httpService";
const ManuService = {

     getmenuList: async () => {
    try {
      const res = await requests.get(`/menu`);
      return res.data;
    } catch (error) {
      throw error.response || error;
    }
  },

    //  createMenu: async (body) => {
    //     return requests.post(`/menu`, body);
    // },
    createMenu: async (formData) => {
    return requests.post(`/menu`, formData, {
        headers: { "Content-Type": "multipart/form-data" } // important!
    });
},
// createMenu: async ({ serviceId, caption, images }) => {
//   try {
//     const formData = new FormData();
//     formData.append("serviceId", serviceId);
//     formData.append("caption", caption);
//     if (images && images.length > 0) {
//       images.forEach((img) => {
//         formData.append("images", img);
//       });
//     }
//     const res = await requests.post(`/menu`, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     return res.data;
//   } catch (error) {
//     throw error.response || error;
//   }
// },
  getMenuById: async (id) => {
    try {
      const res = await requests.get(`/menu/${id}`);
      return res.data;
    } catch (error) {
      throw error.response || error;
    }
  },
// updateMenu: async (id, { serviced, caption, images }) => {
//   try {
//     const formData = new FormData();
//     formData.append("serviced", serviced);
//     formData.append("caption", caption);

//     if (images && images.length > 0) {
//       images.forEach((image) => {
//         if (image instanceof File) {
//           formData.append("images", image);
//         }
//       });
//     }
    
//     const res = await requests.put(`/menu/${id}`, formData, {
//       headers: { "Content-Type": "multipart/form-data" }
//     });
    
//     console.log("Raw response from API:", res); // Debug
//     console.log("res.data:", res.data); // Debug
    
//     // ✅ Make sure we return res.data
//     return res.data; // This should have { status: true, message: "...", data: {...} }
    
//   } catch (error) {
//     console.error("Update error in service:", error);
//     throw error.response || error;
//   }
// },

async updateMenu(id, formData) {
  const res = await requests.put(`/menu/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" } 
  });
  return res;
},
deleteMenu: async (id) => {
        return requests.delete(`/menu/${id}`);
    }



}
export default ManuService;